module.exports = __webpack_public_path__ + "c93887c6.svg";